import { Decimal } from 'decimal.js';

export function setupDecimalConfig() {
  Decimal.set({
    precision: 2,
  });
}
